import { combineReducers } from "redux";

import auth from "./auth"
import snackbar from "./snackbar"

export const reducers = combineReducers({auth, snackbar})